//=====================================
//jquery
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
//=====================================
window.$ = window.jQuery = require('jquery');
global.$ = global.jQuery = require('jquery');
window.App = window.App  || {};
window.Popper = require('@popperjs/core');

import 'jquery-ui/ui/widgets/draggable';

//=====================================
//Bootstrap
import * as bootstrap from 'bootstrap';
// Or import only needed plugins
import { Tooltip as Tooltip, Toast as Toast, Popover as Popover } from 'bootstrap';
// Or import just one
// import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
//=====================================
require('bootstrap');
//=====================================
//Gsap
//=====================================
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import { Draggable } from "gsap/dist/Draggable"; // Draggableを追加
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Draggable);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
window.Draggable = Draggable;
//=====================================
//SplitType
//=====================================
// const SplitType = require('split-type').default;
// window.SplitType = SplitType;

//=====================================
//Swiper
// import Swiper JS
// Swiper, Keyboard, Navigation, Pagination, Controller, History, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Lazy, A11y
//=====================================
const Swiper = require('swiper/bundle').default;
const { Navigation, Pagination, Autoplay, EffectFade } = Swiper;
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
window.Swiper = Swiper;

//=====================================
//FANCY BOX
//=====================================
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

/////////////////////////////////////////////
//MARQUEE #TEST 
/////////////////////////////////////////////
// main.js（最初に貼っていたコードの末尾などに追加）
import { initMarquee } from './inc_marquee';
import { initSlotNumber } from './inc_slotNumber';
import { initGsapAnimations } from './inc_inc_gsapScrollAnim.js';


//////////////////////////////////
//
//////////////////////////////////
window.ChartManager = (() => {
  const charts = new Map();

  function getIsMobile() {
    return window.innerWidth <= 768;
  }

  function init(el) {
    if (!el || charts.has(el)) return;

    const type = el.dataset.chart;
    if (!window.ChartDefinitions || !window.ChartDefinitions[type]) return;

    ScrollTrigger.create({
      trigger: el,
      start: "top 80%",
      once: true,
      onEnter: () => {
        const optionFactory = window.ChartDefinitions[type];

        // ★ CDN の echarts をそのまま使用
        const chart = window.echarts.init(el);

        chart.setOption(
          optionFactory({ isMobile: getIsMobile() }),
          true
        );

        charts.set(el, chart);
      }
    });
  }

  function scan(root = document) {
    root
      .querySelectorAll('.chart-trigger[data-chart]')
      .forEach(init);
  }

  window.addEventListener('resize', () => {
    charts.forEach(chart => chart.resize());
  });

  return { scan };
})();


$(function(){
  // navToggle();
  // contactZip();
  initMarquee();
  initSlotNumber();
  // ページ読み込み時に一括初期化
  initGsapAnimations({
    start: 'top 90%',
    once: true,
    duration: 0.8,
    ease: 'power3.out',
  });



/////////////////////////////
/// CHART TRIGGER
////////////////////////////
ChartManager.scan();





/////////////////////////////
/// 文字サイズの調整JS（お問い合わせTITLE)
////////////////////////////
function autoFitFont(el, min = 12, max = 80) {
if (!el) return;
const parentWidth = el.parentElement.clientWidth;
let fontSize = max;
el.style.whiteSpace = 'nowrap';
// 仮フォントサイズを設定してチェック
el.style.fontSize = fontSize + "px";
// 親幅を超える限り少しずつ小さくする
while (el.scrollWidth > parentWidth && fontSize > min) {
fontSize--;
el.style.fontSize = fontSize + "px";
}
}
function initAutoFit(){
document.querySelectorAll('.js-fit-text').forEach(el => autoFitFont(el));
}
window.addEventListener('load', initAutoFit);
window.addEventListener('resize', initAutoFit);


/////////////////////////////
///
////////////////////////////
  // 初回・Ajax再描画対応
  hideTipsOnAction(); // ← 初期化呼び出し
  document.addEventListener("wpcf7invalid", hideTipsOnAction);

  function hideTipsOnAction() {
    // クリックでエラーを消す
    $(document).on("click", ".wpcf7-not-valid-tip", function () {
      $(this).fadeOut(150);
    });

    // フォーカス時に該当フィールドのエラーを消す
    $(document).on("focus", ".wpcf7-form-control", function () {
      $(this).closest(".wpcf7-form-control-wrap")
        .find(".wpcf7-not-valid-tip")
        .fadeOut(150);
    });
  }
///////////////////////////////////
// スマホ用にテキストMORE
///////////////////////////////////
  $(".js-txt-collapse2").each(function() {
    const $this = $(this);
    const scrollH = $this[0].scrollHeight;
    const maxH = parseFloat($this.css("max-height"));

    // 内容が一定以上ならボタン追加
    if (scrollH > maxH) {
      $this.append('<span class="btn-more">さらに表示</span>');
    }
  });

  // ボタンで展開
  $(document).on("click", ".js-txt-collapse2 .btn-more", function(e) {
    e.preventDefault();
    const $wrap = $(this).closest(".js-txt-collapse2");
    $wrap.addClass("open");
    $(this).fadeOut(200);
  });


///////////////////////////////////
// スマホ用にテキストMORE
///////////////////////////////////
$(".js-txt-collapse").each(function() {
  const $wrap  = $(this);
  const $inner = $wrap.find(".js-txt-inner");

  // SP以外では何もしない（CSS側でも制御してるけど念のため）
  if (window.matchMedia("(min-width: 768px)").matches) {
    return;
  }

  const scrollH = $inner[0].scrollHeight;
  const maxH    = parseFloat($inner.css("max-height"));

  // 内容が一定以上ならボタン追加
  if (scrollH > maxH + 5) { // 誤差分ちょっと足す
    $wrap.append('<span class="btn-more">さらに表示</span>');
  }
});

// ボタンで展開
$(document).on("click", ".js-txt-collapse .btn-more", function(e) {
  e.preventDefault();
  const $wrap = $(this).closest(".js-txt-collapse");
  $wrap.addClass("open");
});




//////////////////////////////////
// 汎用SHOWボタン
//////////////////////////////////

$(function() {
  $('[data-show-target]').on('click', function(e) {
    e.preventDefault();

    const $trigger = $(this);
    const key = $trigger.data('show-target');
    const $target = $('[data-target-content="' + key + '"]');

    // 対象セクションをスライドダウン表示
    $target.stop(true, true).slideDown(500, 'swing', function() {
      $(this).addClass('is-visible');
    });

    // ラッパー(.wrap)があれば優先して消す
    const $wrap = $trigger.closest('.js-wrap');
    if ($wrap.length) {
      $wrap.fadeOut(400, function() { $(this).remove(); });
    } else {
      // ラッパーがない場合はボタン自身だけ消す
      $trigger.fadeOut(300);
    }
  });
});


//////////////////////////////////
// HEADER MENU IMG SWITCH
//////////////////////////////////
$("#menu-main .wrap-in").each(function() {
  const $wrap = $(this);
  const $mainImage = $wrap.find(".switch-img img");
  const defaultImg = $mainImage.attr("src");

  $wrap.find(".c2 a").on("mouseenter", function() {
    const newImgSrc = $(this).data("img");
    if (newImgSrc && $mainImage.attr("src") !== newImgSrc) {
      $mainImage.stop(true, true).fadeOut(100, function() {
        $(this).attr("src", newImgSrc).fadeIn(100);
      });
    }
  });

  $wrap.find(".c2 a").on("mouseleave", function() {
    $mainImage.stop(true, true).fadeOut(100, function() {
      $(this).attr("src", defaultImg).fadeIn(100);
    });
  });
});

  //////////////////////////////////
// 画面幅が992px以上のときのみ `.draggable()` を実行
//////////////////////////////////

  if ($(window).width() >= 992) {
    $('.draggable').draggable();
  }

//////////////////////////////////

//////////////////////////////////
  const $window = $(window);
  const $header = $("#header");
  const headerHeight = $header.length ? $header.outerHeight() : 0;
    const offsetMargin = 120;
    let sections = [];

  ///////////////////////////////
  // アンカースクロール
  ///////////////////////////////
  // function scrollToAnchor(anchorId) {
  //   const targetElement = document.querySelector(anchorId);
  //   if (targetElement) {
  //     const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
  //     window.scrollTo({ top: targetPosition, behavior: "smooth" });
  //   }
  // }
  // if (window.location.hash) {
  //   scrollToAnchor(window.location.hash);
  // }
  // document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  //   anchor.addEventListener("click", function (e) {
  //     e.preventDefault();
  //     scrollToAnchor(this.getAttribute("href"));
  //   });
  // });

function scrollToAnchor(anchor) {
  const el = document.querySelector(anchor);
  if (!el) return;

  const header = document.querySelector("#header");
  const headerHeight = header ? header.offsetHeight : 0;
  const y = el.offsetTop - headerHeight - 10;

  // GSAP ScrollToPlugin が読み込まれていたら GSAP でスクロール
  if (gsap && gsap.to) {
    gsap.to(window, { 
      duration: 0.6, 
      scrollTo: { y: y, autoKill: true },
      ease: "power2.out"
    });
  } else {
    // 普通のスクロール
    window.scrollTo({ top: y, behavior: "smooth" });
  }
}

  ///////////////////////////////
  // SP BURGER MENU
  ///////////////////////////////
  function updateScrollState() {
    if ($window.scrollTop() >= headerHeight) {
      $("body").addClass("is_scroll");
    } else {
      $("body").removeClass("is_scroll");
    }
  }

  // ページ読み込み時に disable-scroll クラスが body にある場合はスクロールイベントを無効化
  setTimeout(function() {
    if (!$("body").hasClass("disable-scroll")) {
      $window.on("scroll load", updateScrollState);
    }
  }, 500);  // 100ミリ秒待ってから実行

  ///////////////////////////////
  // SP BURGER MENU
  ///////////////////////////////
$(document).on("click", "#global-sp-menu a", function () {
  // ignore 指定なら閉じない（別モーダルなど）
  if ($(this).hasClass("menu-close-ignore")) return;

  // SPメニューが開いているときだけ動作
  if ($("body").hasClass("is-sp-menu")) {
    $("#global_burgermenu > button").trigger("click");
  }
});





  ///////////////////////////////
  // NAVI STICKY
  ///////////////////////////////

  // $(".sticky-nav").each(function() {
  //     var $nav = $(this);
  //     var targetSectionID = $nav.data("target");
  //     var $section = $("#" + targetSectionID);
  //     if ($section.length === 0) return; // 対象セクションがない場合はスキップ
  //     var $window = $(window);
  //     var $header = $("#header"); // ヘッダーの高さを考慮する場合
  //     var headerHeight = $header.length ? $header.outerHeight() : 0;
  //     var offsetMargin = 120; // 追加のオフセット

  //     $window.on("scroll", function() {
  //         var scrollTop = $window.scrollTop();
  //         var sectionTop = $section.offset().top - headerHeight - offsetMargin;
  //         var sectionBottom = sectionTop + $section.outerHeight();

  //         if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
  //             $nav.addClass("fixed");
  //         } else {
  //             $nav.removeClass("fixed");
  //         }
  //     });
  // });







  const $menuLinks = $(".sticky-nav li a");
  $menuLinks.each(function () {
    const targetID = $(this).attr("href").split("#")[1];
    const $section = $("#" + targetID).closest("article");
    if ($section.length) {
      sections.push({ id: targetID, $section: $section, $menuItem: $(this).parent("li") });
    }
  });
  function highlightSection() {
    const scrollTop = $window.scrollTop();
    sections.forEach(item => {
      const sectionTop = item.$section.offset().top - headerHeight - offsetMargin;
      const sectionBottom = sectionTop + item.$section.outerHeight();
      item.$menuItem.toggleClass("highlight", scrollTop >= sectionTop && scrollTop < sectionBottom);
    });
  }
  $window.on("scroll", highlightSection);



///////////////////////////////
// SLIDE-DOWN
///////////////////////////////
$(".item-slidedown dt").on("click", function(e) {
  e.preventDefault(); // デフォルト動作を防ぐ

  var parent = $(this).closest(".item-slidedown");
  var answer = parent.find("dd");
  var isOpen = parent.attr("aria-expanded") === "true";

  if (isOpen) {
    parent.attr("aria-expanded", "false");
    answer.slideUp(300);
  } else {
    parent.attr("aria-expanded", "true");
    answer.slideDown(300);
  }
});

// dd 内をクリックしても親要素のイベントを発火させない
$(".item-slidedown dd").on("click", function(e) {
  e.stopPropagation();
});

///////////////////////////////
// SWITCH BUTTON OPEN ALL
///////////////////////////////
$(".toggle").on("click", function() {
  $(this).toggleClass("checked");
  var isChecked = !$(this).find('input[name="check"]').prop("checked");
  $(this).find("input").prop("checked", isChecked);

  // data-target の取得
  var targetSection = $(this).attr("data-target");

  // 該当の section 内の dt 要素を操作
  $("#" + targetSection).find("dt").each(function() {

      if (isChecked) {
          $(this).parent('dl').attr("aria-expanded", "true");
          $(this).next("dd").slideDown(300);
      } else {
          $(this).parent('dl').attr("aria-expanded", "false");
          $(this).next("dd").slideUp(300);
      }
  });
});


/////////////////////////////////////////////
// HEADER DROPDOWN MENU
/////////////////////////////////////////////
  // メニューアイテムを選択
  $('li[aria-expanded]').each(function() {
    var $dropdown = $(this); // 現在のリストアイテム
    var $trigger = $dropdown.find('a'); // 直下のリンク (hover対象)
    var $menu = $dropdown.find('.menu_dropdown'); // ドロップダウンメニュー

    // hover で開く
    $trigger.on('mouseenter', function() {
      $dropdown.attr('aria-expanded', 'true');
      $('body').addClass("is_filter");
    });

    // ドロップダウンメニューにもmouseenterを設定
    $menu.on('mouseenter', function() {
      $dropdown.attr('aria-expanded', 'true');
      $('body').addClass("is_filter");
    });

    // マウスが外れたら閉じる
    $dropdown.on('mouseleave', function() {
      // li から外れたときにメニューが閉じる
      $dropdown.attr('aria-expanded', 'false');
      $('body').removeClass("is_filter");
    });

    // ドロップダウンメニューから外れたときも閉じる
    $menu.on('mouseleave', function() {
      $dropdown.attr('aria-expanded', 'false');
      $('body').removeClass("is_filter");
    });
  });


/////////////////////////////////////////////
//MODAL 外部から呼び出すため
/////////////////////////////////////////////
// window.App.loadSection = function(url, modalId,modalTitle) {
//   $.ajax({
//     type: 'GET',
//     url: url,
//     success: function(data) {
//       $(modalId).find(".ajx_content_output").html(data);
//       $(modalId).find('.modal-title').html(modalTitle);
//       $(modalId).modal('show');
//     }
//   });
// };

window.App = window.App || {}; // Appが未定義の場合は空オブジェクトを作成
window.App.loadSection = function(modalId) {
  console.log("Modal ID:", modalId); // ここでIDを確認
  if (!modalId.startsWith("#")) return; // "#" がない場合は処理しない

  $(modalId).modal('show');
};



///////////////////////////////
// MODAL with numbered nav
///////////////////////////////
window.App = window.App || {};
App.currentContentIndex = 1; // Keep track of the currently displayed index

App.showModalContent = function(modalId, className, title, contentId) {
  const $modal = $('#' + modalId);
  if ($modal.length === 0) {
    console.warn(`Modal with ID "${modalId}" not found.`);
    return;
  }

  // ★ クラスの追加処理（必要に応じて一度削除してから追加）
  if (className) {
    $modal.removeClass(function(index, className) {
      return (className.match(/(^|\s)customClass_\S+/g) || []).join(' ');
    });
    $modal.addClass('customClass_' + className); // プレフィックス付与して他と区別
  }

  // タイトル更新
  $modal.find('.modal-title').text(title);

  // コンテンツの切り替え
  if (contentId) {
    $modal.find('.modal_content_item').addClass('d-none');
    const $target = $modal.find(contentId);
    if ($target.length > 0) {
      $target.removeClass('d-none');
      const match = contentId.match(/(\d+)$/);
      if (match) {
        App.currentContentIndex = parseInt(match[1]);
        // App.highlightActiveButton($modal);
      }
    } else {
      console.warn(`Content section "${contentId}" not found inside modal "${modalId}".`);
    }
  }

  // モーダル表示
  const modalInstance = bootstrap.Modal.getOrCreateInstance($modal[0]);
  modalInstance.show();
};


// Switch content based on the button clicked
App.switchTo = function(contentId, title = null) {
  const $button = $(event.target);
  const $modalDialog = $button.closest('.modal-dialog');
  const $modal = $modalDialog.closest('.modal');

  // 現在のモーダル内のコンテンツを非表示
  $modal.find('.modal_content_item').addClass('d-none');

  // 対象コンテンツを表示
  const $target = $modal.find(`#${contentId}`);
  if ($target.length > 0) {
    $target.removeClass('d-none');
  }

  // タイトルを変更（任意）
  if (title) {
    $modal.find('.modal-title').text(title);
  }

  // すでに付いている customClass_X をすべて削除
  $modal.removeClass(function(index, className) {
    return (className.match(/customClass_\d+/g) || []).join(' ');
  });

  // data-index を読み取って customClass_X を付ける
  const index = $button.data('index');
  if (index) {
    $modal.addClass('customClass_' + index);
  }
};






///////////////////////////////
// MODAL with IFRAME
///////////////////////////////
App.loadIframe = function(url, modalId, title) {
  const $modal = $('#' + modalId);
  if ($modal.length === 0) {
    console.warn(`Modal with ID "${modalId}" not found.`);
    return;
  }

  // タイトル更新
  if (title) {
    $modal.find('.modal-title').text(title);
  }

  const $iframe = $modal.find('iframe');

  // src 差し替え
  $iframe.attr('src', url);

  // モーダル表示
  const modalInstance = bootstrap.Modal.getOrCreateInstance($modal[0]);
  modalInstance.show();
};
//modal を閉じたときの後始末
$('#modal-iframe').on('hidden.bs.modal', function () {
  $(this).find('iframe').attr('src', '');
});













/////////////////////////////////////////////
// SP BURGER MENU
/////////////////////////////////////////////
$('#global_burgermenu > button').on('click', function() {

  $(this).toggleClass('active');

  if($(this).hasClass('active')){
      // ▼ 開く
      $('body').removeClass('rm-sp-menu is-sp-menu-closing');
      $('body').addClass('is-sp-menu');
  } else {
      // ▼ 閉じる（即 is-sp-menu を消さない！フェードアウトさせる）
      $('body').addClass('is-sp-menu-closing');
      // ▼ フェードアウト時間（CSSと合わせて 600ms）
      setTimeout(function() {
          $('body').removeClass('is-sp-menu is-sp-menu-closing').addClass('rm-sp-menu');
      }, 200);
  }
  return false;
});


//=====================================
//Swiper Slide 1
//=====================================
window.App.initializeSwiper = function(containerId, menuId, perView) {
  if (typeof perView !== 'number' || isNaN(perView)) {
    console.error('perView must be a number.');
    return;
  }
  var menuSwiper = new Swiper(menuId, {
    slidesPerView: perView,
    // spaceBetween: 0,
    allowSlideNext: false,
    allowSlidePrev: false,
  });
  var mainSwiper = new Swiper(containerId, {
    loop: true,
    spaceBetween: 0,
    clickable: true,
    speed: 300,
    thumbs: {
      swiper: menuSwiper,
    },
  });
}

/* ==================
FANCYBOX
===================== */
  // すべての `data-fancybox` 属性を持つ要素を取得
  const fancyboxGroups = new Set(
    [...document.querySelectorAll("[data-fancybox]")].map(el => el.getAttribute("data-fancybox"))
  );

  // 取得した各 `data-fancybox` の値に対して Fancybox をバインド
  fancyboxGroups.forEach(group => {
    Fancybox.bind(`[data-fancybox='${group}']`, {
      Thumbs: {
        autoStart: true,
        hideOnClose: true,
        type: "classic",
      },
      Carousel: {
        Navigation: false,
        transition: "slide",
        infinite: true,
      },
      Toolbar: {
        display: {
          left: [],
          middle: ["prev", "infobar", "next"],
          right: ["close"],
        },
      },
      Image: {
        fit: "contain",
      },
      Slideshow: {
        autoStart: false,
        speed: 3000,
      },
      Keyboard: {
        Escape: true,
        Delete: false,
      },
      Hash: false,
      caption: function (fancybox, slide) {
        let caption = slide.triggerEl.dataset.caption || '';
        let content = slide.triggerEl.dataset.content || '';

        return `
          ${caption ? `<h3 class="fancy_caption">${caption}</h3>` : ''}
          ${content ? `<span class="fancy_content">${content}</span>` : ''}
        `;
      }
    });
  });











///////////////////////////////
// GSAP BAR
///////////////////////////////

// .bar1要素のアニメーション
$(".bar1").each(function(index, element) {
  var width = $(element).width(); // バーの現在の幅を取得
  var targetWidth = parseInt($(element).css("width")); // 目標の幅を取得
  $(element).css("width", "0px");
  gsap.to(element, {
    scrollTrigger: {
      trigger: element,
      start: "top 80%", 
      end: "bottom 20%",
    },
    width: targetWidth + "px",
    duration: .5,
    ease: "power2.inOut", 
  });
});

$(".bar2").each(function(index, element) {
  var height = $(element).height(); 
  var targetHeight = parseInt($(element).css("height")); 
  $(element).css("height", "0px");
  gsap.to(element, {
    scrollTrigger: {
      trigger: element, 
      start: "top 80%", 
      end: "bottom 20%",
    },
    height: targetHeight + "px",
    duration: .5,
    ease: "power2.inOut", 
  });
});

















//////////////////////////////
// カウントアップ
//////////////////////////////
setTimeout(function () {

  // =====================================
  // 設定値（ここだけ触れば挙動変更可）
  // =====================================
  var DEFAULT_ZERO_ANIMATE_START = 100; // 最終値が0のときの開始値
  var DURATION = 800;

  $(".txt-num > i, .count-num > i").each(function () {

    var $target = $(this);
    var targetText = $target.text().trim();

    // 初期状態
    $target.removeClass("is-counting is-done");

    // -------------------------------------
    // 数値抽出（小数点対応）
    // -------------------------------------
    var numericText = targetText.replace(/[^0-9.]/g, "");
    if (!numericText) return;

    var isFloat = numericText.indexOf(".") !== -1;
    var targetNumber = isFloat
      ? parseFloat(numericText)
      : parseInt(numericText, 10);

    if (isNaN(targetNumber)) return;

    var decimalLength = isFloat
      ? (numericText.split(".")[1]?.length || 0)
      : 0;

    var intPaddingLength = numericText.split(".")[0].length;

    var hasAnimated = false;

    // -------------------------------------
    // 初期表示値（必ず 0）
    // -------------------------------------
    var displayInitialValue = isFloat
      ? (0).toFixed(decimalLength)
      : "0".padStart(intPaddingLength, "0");

    //表示用に初期値を書き換える
    // $target.text(displayInitialValue);

    // -------------------------------------
    // アニメーション開始・終了値
    // -------------------------------------
    var isZeroTarget = targetNumber === 0;

    // アニメ開始値（表示用とは別）
    var animateStartValue = isZeroTarget
      ? DEFAULT_ZERO_ANIMATE_START
      : 0;

    // アニメ終了値
    var animateEndValue = targetNumber;

    // -------------------------------------
    // アニメーション本体
    // -------------------------------------
    function animateNumber() {
      if (hasAnimated) return;
      hasAnimated = true;

      $target.addClass("is-counting");

      $({ countNum: animateStartValue }).animate(
        { countNum: animateEndValue },
        {
          duration: DURATION,
          easing: "linear",

          step: function (now) {
            var value;

            if (isFloat) {
              value = now.toFixed(decimalLength);
              var parts = value.split(".");
              parts[0] = parts[0].padStart(intPaddingLength, "0");
              value = parts.join(".");
            } else {
              value = Math.floor(now)
                .toString()
                .padStart(intPaddingLength, "0");
            }

            $target.text(value);
          },

          complete: function () {
            var finalValue = isFloat
              ? animateEndValue.toFixed(decimalLength)
              : animateEndValue.toString().padStart(intPaddingLength, "0");

            $target.text(finalValue);

            $target
              .removeClass("is-counting")
              .addClass("is-done");
          }
        }
      );
    }

    // -------------------------------------
    // ScrollTrigger
    // -------------------------------------
    gsap.to({}, {
      duration: 0.01,
      scrollTrigger: {
        trigger: $target.parent()[0],
        start: "top 80%",
        onEnter: animateNumber,
        once: true
      }
    });

  });

}, 800);
//////////////////////////////////
// gsap.registerPlugin(ScrollTrigger);
//////////////////////////////////
  gsap.registerPlugin(ScrollTrigger);
  const dls = document.querySelectorAll(".lst-history dl");
  dls.forEach((dl) => {
    gsap.fromTo(dl,
      { scale: 0.1, opacity: 0 }, // 初期状態（小さく、透明）
      { 
        scale: 1, opacity: 1, duration: 0.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: dl,
          start: "top 95%",  // 要素の上端が画面の75%位置に来たら開始
          end: "top 80%",    // 画面の40%位置までアニメーション
          scrub: true,       // スクロールと連動
          toggleActions: "play reverse play reverse" // スクロールを戻すと元に戻る
        }
      }
    );
  });

///////////////////////////////
// GSAPアニメーション（修正後）
///////////////////////////////
// .parallax-bg が存在する場合のみ GSAP 実行
if (document.querySelector(".parallax-bg")) {
  gsap.to(".parallax-bg", {
    y: 300,
    scrollTrigger: {
      trigger: ".parallax-bg",
      start: "top bottom",
      end: "bottom top",
      scrub: 0.5
    }
  });
}
});












// =====================================
// ScrollTrigger はロード直後は一時停止
// =====================================
ScrollTrigger.getAll().forEach(t => t.disable());

let scrollInitDone = false;
window.addEventListener("scroll", function() {
  if (!scrollInitDone) {
    scrollInitDone = true;

    setTimeout(() => {
      ScrollTrigger.getAll().forEach(t => t.enable());
      ScrollTrigger.refresh();
    }, 50); // ← ここもアンカーより後に再開させる
  }
});

////////////////////////////////////////////////
// ハッシュが削除）
////////////////////////////////////////////////
setTimeout(() => {
  if (window.location.hash) {
    history.replaceState(null, "", window.location.pathname + window.location.search);
  }
}, 5000);
////////////////////////////////////////////////
// ハッシュがアンカー移動に使われた場合のみ削除）
////////////////////////////////////////////////
// document.querySelectorAll('a[href^="#"]').forEach(a => {
//   a.addEventListener("click", () => {
//     setTimeout(() => {
//       history.replaceState(null, "", window.location.pathname + window.location.search);
//     }, 3000);
//   });
// });





// ////////////////////////////////////
// /// DEV
// ////////////////////////////////////
// $(".dev-bg i").on("click", function(e) {
//   e.preventDefault();
//   var classNum = $(this).data("bg");
//   if(classNum === "none"){
//       $(this).parent(".dev-bg").remove();
//   }
//   $(this).closest("SECTION, .swiper-slide").removeClass(function(index, className) {
//       return (className.match(/(^|\s)mv-\S+/g) || []).join(" ");
//   }).addClass("mv-" + classNum);
//   });
//   $('[data-js="add_hover"]').hover(function() {
//   $(this).closest('SECTION').addClass('is_hover');
//   }, function() {
//   $(this).closest('SECTION').removeClass('is_hover');
//   });
  

// /////////////////////////////////////////////
// //DEV TARGET KILL
// /////////////////////////////////////////////
// $(".kill").on("click", function() {
//   if (confirm("本当に削除しますか？")) {
//       $(this).closest(".targetkill").hide();
//   }
// });

// $("#dev-print-r").on("dblclick", function() {
//   $(this).fadeOut(500); // 500ms（0.5秒）かけてフェードアウト
// });
// /////////////////////////////////////////////
// //SITEMAP
// /////////////////////////////////////////////
// window.App.loadSection = function(modalId) {
//   $.ajax({
//     success: function(data) {
//       $(modalId).modal('show');
//     }
//   });
// };

/////////////////////////////////////////////
    // ACF カラーピッカーのカスタムカラーを設定
/////////////////////////////////////////////
// acf.add_filter('color_picker_args', function( args, $field ){
//     // カスタムカラーの配列を設定
//     args.palettes = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#000000', '#ffffff'];
//     return args;
// });

// // #an-kaori が存在する場合のみ GSAP 実行
// if (document.querySelector("#an-kaori")) {
//   gsap.fromTo("#an-kaori",
//     { scale: 1, opacity: 0, x: "-500px" },
//     { 
//       scale: 1, opacity: 1, x: 0, duration: 1, ease: "power2.out",
//       onComplete: () => {
//         gsap.to("#an-kaori", {
//           scale: 1.1, y: 3, duration: 2.5, repeat: -1, yoyo: true, ease: "sine.inOut"
//         });
//       }
//     }
//   );
// }
//=====================================
//Muuri
//=====================================
// const Muuri = require('muuri').default;
// window.Muuri = Muuri;

//////////////////////////////////
// 汎用SHOWボタン
//////////////////////////////////
// $(".js-btn-show-next-hidden").on("click", function(){
//   var $btn = $(this);
//   var $nextHidden = $btn.closest(".wrap-btn-show-next-hidden").nextAll(".hidden").first(); // 次の .hidden を探す

//   if ($nextHidden.length) {
//       $nextHidden.slideDown(300); // アニメーションで表示
//       $btn.addClass("is_done"); // ボタンをフェードアウト
//   }
// });
